/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener("DOMContentLoaded", function () {
  const scrollArrow = document.querySelector(".tab-scroll-arrow");
  if (scrollArrow) {
    scrollArrow.addEventListener("click", function () {
      const tabNav = document.querySelector(".tab-nav");
      if (tabNav) {
        tabNav.scrollBy({
          left: 150,
          behavior: "smooth",
        });
      }
    });
  }
});

$(document).ready(function () {
  $(".load-more-btn").on("click", function () {
    $(".product-container .multi-column__item").css("display", "block");
    $(".product-container .load-more-btn").css("display", "none");
  });

  if ($("body").find("a[data-fancybox]").length > 0) {
    $("[data-fancybox]").fancybox({
      toolbar: false,
      smallBtn: false,
      iframe: {
        preload: false,
      },
    });
  }
  $(".product-accordion .accordion-item").on("click", function () {
    // Close all other open answers
    $(".product-accordion .accordion-item .collapse-block").slideUp();
    $(".product-accordion .accordion-item").removeClass("active");

    const answerBlock = $(this).find(".collapse-block");

    // Toggle clicked item
    if (!answerBlock.is(":visible")) {
      answerBlock.slideDown();
      $(this).addClass("active");
    }
  });

  // Trigger first accordion item open if available
  if ($(".product-accordion .accordion-item").length > 0) {
    $(".product-accordion .accordion-item").first().trigger("click");
  }
});
